import React, { FC, useCallback, useContext, useEffect, useMemo } from 'react';
import { SheetField } from '../../../../../types';
import { StepContext } from '../../../../../../creator/step.context';
import { getCurrentField } from '../../../../../steps/helpers';
import cn from 'classnames';
import styles from './styles.module.scss';
import { isIphoneOrIpad } from '../../../../../../../../helpers';
import { useFormContext } from 'react-hook-form';

type SheetContentProps = React.ComponentPropsWithoutRef<'div'> & { fieldsList: SheetField[] };

export const SheetContent: FC<SheetContentProps> = (props) => {
    const { className, fieldsList, ...other } = props;
    const { focusedField, currentStepConfig } = useContext(StepContext);
    const form = useFormContext();

    const { clearErrors } = form;

    const { field: currentField } = useMemo(
        () => getCurrentField(fieldsList, focusedField),
        [fieldsList, focusedField],
    );

    const setFocusOnField = useCallback(
        (focusedField?: string | null) => {
            if (!focusedField || currentStepConfig.ignoringFocusFields?.includes(focusedField)) {
                return;
            }
            clearErrors(focusedField);
            const element = document.getElementsByName(focusedField)[0];
            const isMobileWebkit = isIphoneOrIpad(navigator.userAgent || '');
            if (element && element.focus && !isMobileWebkit) {
                element.focus();
            }
        },
        [clearErrors, currentStepConfig],
    );

    useEffect(() => {
        setFocusOnField(focusedField);
    }, [focusedField]);

    const CurrentFieldView = currentField ? currentField.view : null;

    return (
        <div className={cn(styles['sheet-content'], className)} {...other}>
            {CurrentFieldView && <CurrentFieldView label="" fieldsList={fieldsList} isShowingOnSheet />}
        </div>
    );
};
